import i18n from "../i18n";

export const handlePrint = (studentData) => {
    const printContent = `
      <div>
        <h2>${i18n.t("HOUARI BOUMEDIENE RECEIPT")}</h2>
        <p>Date: ${new Date().toLocaleDateString()}</p>
        <hr />
        <p>First Name: ${studentData.firstName}</p>
        <p>Last Name: ${studentData.lastName}</p>
        <p>Email: ${studentData.email}</p>
        <p>Phone: ${studentData.phone}</p>
        <hr />
        <p>${i18n.t("Subscriptions:")}</p>
        <ul>
          ${studentData.enrollments
            .map((enrollment) => `<li>${enrollment.groupName}</li>`)
            .join("")}
        </ul>
        <hr />
      </div>
    `;
  
    const printWindow = window.open("", "", "width=800,height=600");
    printWindow.document.write(`
      <html>
        <head>
          <title>${i18n.t("Receipt")}</title>
        </head>
        <body>${printContent}</body>
      </html>
    `);
    printWindow.document.close();
    printWindow.print();
  };
  
